export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const endpointId = config.public.MINDBOX_ENDPOINT_ID as string;

  if (!endpointId) return;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const w = window as any;
  w.mindbox = w.mindbox || function (...args: unknown[]) { w.mindbox.queue.push(args); };
  w.mindbox.queue = w.mindbox.queue || [];
  w.mindbox('create', { endpointId });

  const script = document.createElement('script');
  script.src = 'https://api.s.mindbox.ru/scripts/v1/tracker.js';
  script.async = true;
  script.onerror = () => {
    delete w.mindbox;
  };
  document.head.appendChild(script);
});
